import { LoadingButton } from "@mui/lab";
import { CSSProperties, useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../../context";

// ----------------------------------------------------------------------

export const ConnectBtn = () => {
	const { values } = useContext(Context);
	const { buttonBackgroundColor, buttonFullWidth, buttonShape, buttonTextColor, buttonTextWeight } =
		values;

	const { translate } = useLocales();

	const buttonStyle: CSSProperties = {
		borderRadius: buttonShape,
		backgroundColor: buttonBackgroundColor,
		width: buttonFullWidth,
		color: buttonTextColor,
		fontWeight: buttonTextWeight === "BOLD" ? 700 : 500
	};

	return (
		<LoadingButton
			variant='contained'
			size='large'
			sx={{ mt: 5, width: "100%", alignSelf: "center" }}
			style={buttonStyle}
		>
			{translate("connect_panel.connect")}
		</LoadingButton>
	);
};

export default ConnectBtn;
